export default "__VITE_ASSET__ZQKrp4hq__"